export default __webpack_public_path__ + "static/media/undraw_medicine_b1ol_(2).e0cf9bf4.svg";